import { createFileRoute } from "@tanstack/react-router";
import { IntegrationDetail } from "@/pages/IntegrationDetail";
import { integrationPages } from "@/lib/integration-pages";
import { buildHead } from "@/lib/seo-head";

const page = integrationPages["stripe"];
if (!page) throw new Error("Integração não cadastrada");

export const Route = createFileRoute("/crm-integrado-stripe")({
  head: () => buildHead({
    title: page.metaTitle,
    description: page.metaDescription,
    path: "/crm-integrado-stripe",
  }),
  component: () => <IntegrationDetail integrationKey="stripe" />,
});
